// TMDB API Configuration
export const TMDB_CONFIG = {
  // JWT Token for TMDB API v4 (preferred method)
  JWT_TOKEN: process.env.REACT_APP_TMDB_JWT_TOKEN || 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI',
  // Legacy API Key for v3 (fallback)
  API_KEY: process.env.REACT_APP_TMDB_API_KEY || 'YOUR_TMDB_API_KEY',
  BASE_URL: 'https://api.themoviedb.org/3',
  IMAGE_BASE_URL: 'https://image.tmdb.org/t/p',
  ENDPOINTS: {
    UPCOMING_MOVIES: '/movie/upcoming',
    POPULAR_MOVIES: '/movie/popular',
    TOP_RATED_MOVIES: '/movie/top_rated',
    NOW_PLAYING_MOVIES: '/movie/now_playing',
    TRENDING_MOVIES: '/trending/movie/week',
    MOVIE_DETAILS: '/movie',
    SEARCH_MOVIES: '/search/movie',
    // TV Shows endpoints
    POPULAR_TV: '/tv/popular',
    TOP_RATED_TV: '/tv/top_rated',
    TRENDING_TV: '/trending/tv/week',
    TV_DETAILS: '/tv',
    SEARCH_TV: '/search/tv',
    // General endpoints
    SEARCH_MULTI: '/search/multi'
  }
};

// Helper function to build API URL with authentication
export const buildApiUrl = (endpoint, params = {}) => {
  const url = new URL(`${TMDB_CONFIG.BASE_URL}${endpoint}`);
  url.searchParams.append('api_key', TMDB_CONFIG.API_KEY);
  
  // Add additional parameters
  Object.keys(params).forEach(key => {
    url.searchParams.append(key, params[key]);
  });
  
  return url.toString();


  // ----
};

// Helper function to get full image URL
export const getImageUrl = (path, size = 'w1280') => {
  if (!path) return 'https://via.placeholder.com/1920x1080';
  return `${TMDB_CONFIG.IMAGE_BASE_URL}/${size}${path}`;
};

// Helper function to get poster URL
export const getPosterUrl = (path, size = 'w500') => {
  if (!path) return 'https://via.placeholder.com/500x750';
  return `${TMDB_CONFIG.IMAGE_BASE_URL}/${size}${path}`;
};
